import { env } from '../env';

const stripSubdomain = (hostname: string, subdomain: string): string => {
  if (!hostname) {
    return '';
  }

  const prefix = `${subdomain}.`;
  if (hostname.startsWith(prefix)) {
    return hostname.substring(prefix.length);
  }
  return hostname;
};

const getFallbackDomain = (): string => {
  try {
    const globalApiHost = new URL(env.GLOBAL_API_URL).hostname;
    return stripSubdomain(globalApiHost, 'globalapi');
  } catch (error) {
    console.error('Failed to derive fallback domain from GLOBAL_API_URL:', error);
    return '';
  }
};

export const getBaseDomain = (): string => {
  if (typeof window === 'undefined') {
    return getFallbackDomain();
  }

  const { hostname, protocol } = window.location;
  const parts = hostname.split('.');
  const domain = parts.slice(-2).join('.');

  if (protocol === 'https:' && domain) {
    return domain;
  }

  const fallback = getFallbackDomain();
  return fallback || domain;
};

export const getGlobalApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const domain = getBaseDomain();

  if (domain) {
    return `https://globalapi.${domain}${normalizedPath}`;
  }

  const base = env.GLOBAL_API_URL.replace(/\/?$/, '');
  return `${base}${normalizedPath}`;
};

export const getAppUrl = (): string => {
  const domain = getBaseDomain();
  if (domain) {
    return `https://app.${domain}/`;
  }

  const fallback = env.APP_URL.endsWith('/') ? env.APP_URL : `${env.APP_URL}/`;
  return fallback;
};
